<template>
  <div class="mc-report-view__table">
    <div class="row">
      <!-- Search -->
      <div class="col-md-12">
        <div class="mc-table-view">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
            <label class="d-inline-flex align-items-center mc-table-view__search">
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                v-model="filter"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="ms-2"
                @input="searchData"
              ></b-form-input>
            </label>
          </div>
        </div>
      </div>
      <!-- End search -->
    </div>

    <!-- <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-card>
            <b-skeleton-table
              :rows="3"
              :columns="fields.length"
              :table-props="{ bordered: false, striped: true }"
            >
            </b-skeleton-table>
          </b-card>
        </template>
        <div class="datatables table-responsive-sm">
            <table class="table b-table table-sm" aria-describedby="Summary Vehicle Outside Geofence Table">
                <thead>
                    <tr>
                        <th v-for="field in fields" id="header" :key="field.key" :rowspan="field.headerRowspan"
                            style="text-align: left">
                            {{ field.label }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="report in drivingBehaviour"
                        :key="report.duration">
                        <td v-for="key in selectedData" :key="key">
                            {{
                                key == 'createdOn'
                                ? momentDMYH(report.createdOn)
                                : key == 'vehicleType'
                                ? `${report.vehicle.vehicleType.manufacturer} / ${report.vehicle.vehicleType.model} / ${report.vehicle.vehicleType.type}`
                                : key == 'vehicle'
                                ? report.vehicle.licensePlate
                                : key == 'driver' && report.driver
                                ? report.driver.fullname
                                : key == 'alert'
                                ? report.alert.descriptionIdn
                                : key == 'alertData'
                                ? report.alertData && report.alertData
                                : key == 'address'
                                ? report.address
                                : '-'
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
      </b-skeleton-wrapper>
    </div> -->

    <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-card>
            <b-skeleton-table :rows="3" :columns="fields.length" :table-props="{ bordered: true, striped: true }">
            </b-skeleton-table>
          </b-card>
        </template>
        <b-table class="datatables" :items="listData" :fields="fields" responsive="md" show-empty
          :empty-text="$t('global.emptyTable')" 
          :per-page="perPage"
          :empty-filtered-text="$t('global.emptyFilteredTable')" 
          :filter="filter"
          :filter-included-fields="filterOn" @filtered="onFiltered">
          <template #cell(createdOn)="data">
            {{ data.item ? momentDateShortMonth(data.item.createdOn) : '-'}}
            <br />
            <span class="text-muted">{{ data.item ? momentTimeSeconds(data.item.createdOn) : '-' }}</span>
          </template>

          <template #cell(vehicleType)="data">
            {{ data.item.vehicle ? (data.item.vehicle.vehicleType ? data.item.vehicle.vehicleType.manufacturer : '-') : '-'}} /
            {{ data.item.vehicle ? (data.item.vehicle.vehicleType ? data.item.vehicle.vehicleType.model : '-') : '-'}} /
            {{ data.item.vehicle ? (data.item.vehicle.vehicleType ? data.item.vehicle.vehicleType.type : '-') : '-'}} 
          </template>

          <template #cell(vehicle)="data">
            {{ data.item.vehicle ? data.item.vehicle.licensePlate : '-'}} 
          </template>

          <template #cell(driver)="data">
            {{ data.item.driver ? data.item.driver.fullname : '-'}} 
          </template>

          <template #cell(alert)="data">
            {{ data.item.alert ? data.item.alert.descriptionIdn : '-'}} 
          </template>
        </b-table>
      </b-skeleton-wrapper>
    </div>
    <div class="row mt-3" v-if="fields.length > 0">
        <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                    {{ $t('global.text.displays') }}
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions"
                        @input="changePerPage">
                    </b-form-select>
                    {{ $t('global.text.entries') }}.
                    <p>
                        {{ $t('global.text.display') }}
                        <strong>{{ totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0 }}</strong> -
                        <strong>{{ Math.min(totalRows, currentPage * perPage) }}</strong>
                        {{ $t('global.object.of') }}
                        <strong>{{ totalRows }}</strong>
                    </p>
                </label>
            </div>
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows"
                        :per-page="perPage" @change="changePage">
                    </b-pagination>
                </ul>
            </div>
        </div>
    </div>
  </div>
</template>
  
  <script>
import { GET_DRIVER_BEHAVIOR_REPORT } from '@/services/api/report/report'
import moment from 'moment'
import { Helper, debounce } from '@/mixin/helper'
import { Export } from '@/mixin/export'
moment.locale('id')

export default {
  name: 'DrivingBehaviourTable',
  mixins: [Helper, Export],
  data() {
    return {
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      vehicleGeofenceHist: {
        vehicleGeofenceHist: [],
      },
      drivingBehaviour: [],
      fields: [],
      isLoading: false,
      fileName: '',
      openSection: false,
      periode: [],
      filteredItems: [],
      selectedData: [],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.drivingBehaviour.length
    },
    listData() {
      return this.drivingBehaviour
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.drivingBehaviour.length
  },
  methods: {
    /**
     * Search the table data with search input
     */
    selectValues(data, key) {
        const result = []

        // Recursive helper function
        function selectHelper(obj) {
            const selectedValues = obj[key]
            if (selectedValues) {
                result.push(selectedValues)
            }
        }

        data.forEach((obj) => selectHelper(obj))
        return result
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    changePerPage(perPage) {
        this.perPage = perPage
        this.currentPage = 1
        this.refreshData(this.periode, this.filterGeofence, this.filterVehicle, this.fields)
    },

    changePage(page) {
        this.currentPage = page
        this.refreshData(this.periode, this.filterGeofence, this.filterVehicle, this.fields)
    },

    searchData: debounce(function () {
        this.currentPage = 1
        this.refreshData(this.periode, this.filterGeofence, this.filterVehicle, this.fields)
    }, 500),

    refreshData(periode, filter, filterDriver, fields) {
      this.drivingBehaviour = []
      if (fields.length == 0) {
        this.drivingBehaviour = []
        return
      }
      this.fields = fields
      this.isLoading = true
      this.periode = periode
      var filters = {}
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        }
      }

      var filterDrivers = {}
      if (filterDriver !== undefined && filterDriver.length > 0) {
        filterDrivers = {
          driverId: filterDriver,
        }
      }
      // this.currentPage = this.perPage > 10 ? 1 : this.currentPage
      var filterVar = {
        startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
        endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
        search: this.filter || undefined,
        pagination: {
            page: this.currentPage,
            show: this.perPage,
        },
        ...filters,
        ...filterDrivers
      }
      this.selectedData = this.selectValues(fields, 'key')
      
      var self = this
      var getData = this.$apollo
        .query({
          query: GET_DRIVER_BEHAVIOR_REPORT,
          variables: {
            filter: filterVar,
          },
          fetchPolicy: 'no-cache',
        })
        .then((res) => {
          var data = res.data
          self.totalRows = data.reportDriverBehaviour.reportDriverBehaviour.pagination.total
          if (self.totalRows === 0) {
            self.drivingBehaviour = []
            self.isLoading = false
            return []
          }

          self.drivingBehaviour = data.reportDriverBehaviour.reportDriverBehaviour.data
          self.filteredItems = data.reportDriverBehaviour.reportDriverBehaviour.data

          self.isLoading = false
        })

      return getData
    },

    openTable(periode, filter, filterDriver, fields) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.refreshData(periode, filter, filterDriver, fields)
          this.openSection = false
        }, 500)
      })
    },

    downloadToExcel(periode, filter, filterDriver, fields) {
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }
      var filterDrivers = {};
      if (filterDriver !== undefined && filterDriver.length > 0) {
        filterDrivers = {
          driverId: filterDriver,
        };
      }

      var filterVar = {
        startDate: moment(periode[0] + " 00:00:00.000").toISOString(),
        endDate: moment(periode[1] + " 23:59:59.000").toISOString(),
        column: fields.map((item) => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters,
        ...filterDrivers,
      };

      var downloadProgress = {
        name:
          "Excessive Driver Behavior " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".xlsx",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "excel",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      console.log(filterVar)
      let filename =
          "Excessive Driver Behavior " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".xlsx"
      let title = "Excessive Driving Behaviour Report"
      let subtitle = `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}`
      this.exportToExcel (fields, this.drivingBehaviour, filename, title, subtitle)
      setTimeout(() => {
        clearInterval(intervalDownload);
        this.$parent.$parent.$parent.refreshDownloadHistory();
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: 100,
        });
        this.$store.commit("report/deleteProgress", downloadProgress);
      }, 2000);

      // var self = this;
      // this.$apollo
      //   .query({
      //     query: null,
      //     variables: {
      //       filter: filterVar,
      //     },
      //     fetchPolicy: "no-cache",
      //   })
      //   .then((res) => {
      //     var isSuccessful = res.data.excelReportGeolocation.isSuccessful;
      //     if (isSuccessful) {
      //       clearInterval(intervalDownload);
      //       self.$parent.$parent.$parent.refreshDownloadHistory();
      //       setTimeout(() => {
      //         self.$store.commit("report/updateProgress", {
      //           progress: downloadProgress,
      //           percentage: 100,
      //         });
      //         self.$store.commit("report/deleteProgress", downloadProgress);
      //       }, 500);
      //     } else {
      //       clearInterval(intervalDownload);
      //       self.$parent.$parent.$parent.refreshDownloadHistory();
      //       setTimeout(() => {
      //         self.$store.commit("report/updateProgress", {
      //           progress: downloadProgress,
      //           percentage: 90,
      //         });
      //         self.$store.commit("report/deleteProgress", downloadProgress);
      //       }, 500);
      //     }
      //   });
    },

    downloadToPdf(periode, filter, filterDriver, fields) {
      var filters = {};
      if (filter !== undefined && filter.length > 0) {
        filters = {
          vehicleId: filter,
        };
      }
      var filterDrivers = {};
      if (filterDriver !== undefined && filterDriver.length > 0) {
        filterDrivers = {
          driverId: filterDriver,
        };
      }
      var filterVar = {
        startDate: moment(periode[0] + " 00:00:00.000").toISOString(),
        endDate: moment(periode[1] + " 23:59:59.000").toISOString(),
        column: fields.map((item) => item.header),
        subtitle: `Periode : ${this.momentDateLongMonth(
          periode[0]
        )} - ${this.momentDateLongMonth(periode[1])}`,
        ...filters,
        ...filterDrivers,
      };

      var downloadProgress = {
        name:
          "Excessive Driver Behavior " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".pdf",
        periode:
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY"),
        downloadedAt: moment().format("DD MMM YYYY HH:mm:ss"),
        percentage: 0,
        type: "pdf",
      };
      this.$store.commit("report/saveProgress", downloadProgress);

      var percentage = 0;
      var intervalDownload = setInterval(() => {
        if (percentage < 75) {
          percentage += 25;
        } else if (percentage == 75) {
          percentage = 90;
        } else if (percentage == 90) {
          clearInterval(intervalDownload);
        }
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: percentage,
        });
      }, 500);

      console.log(filterVar)
      let filename = 
          "Excessive Driver Behavior " +
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY") +
          ".pdf"
      let title = "Excessive Driving Behaviour Report"
      let subtitle = 
          moment(periode[0]).format("DD MMM YYYY") +
          " - " +
          moment(periode[1]).format("DD MMM YYYY")
      fields = fields.map( item => {
        return {
          header: item.label,
          key: item.key
        }
      })
      this.exportTableToPdf (fields, this.drivingBehaviour, filename, null, title, subtitle)
      setTimeout(() => {
        clearInterval(intervalDownload);
        this.$parent.$parent.$parent.refreshDownloadHistory();
        this.$store.commit("report/updateProgress", {
          progress: downloadProgress,
          percentage: 100,
        });
        this.$store.commit("report/deleteProgress", downloadProgress);
      }, 2000);

      // var self = this;
      // this.$apollo
      //   .query({
      //     query: EXPORT_PDF_REPORT_GEOLOCATION,
      //     variables: {
      //       filter: filterVar,
      //     },
      //     fetchPolicy: "no-cache",
      //   })
      //   .then((res) => {
      //     var isSuccessful = res.data.pdfReportGeolocation.isSuccessful;
      //     if (isSuccessful) {
      //       clearInterval(intervalDownload);
      //       self.$parent.$parent.$parent.refreshDownloadHistory();
      //       setTimeout(() => {
      //         self.$store.commit("report/updateProgress", {
      //           progress: downloadProgress,
      //           percentage: 100,
      //         });
      //         self.$store.commit("report/deleteProgress", downloadProgress);
      //       }, 500);
      //     } else {
      //       clearInterval(intervalDownload);
      //       self.$parent.$parent.$parent.refreshDownloadHistory();
      //       setTimeout(() => {
      //         self.$store.commit("report/updateProgress", {
      //           progress: downloadProgress,
      //           percentage: 90,
      //         });
      //         self.$store.commit("report/deleteProgress", downloadProgress);
      //       }, 500);
      //     }
      //   });
    },
  },
}
</script>